class INTENT.widgets.VastInfo

  @ATTR_NAME: "data-widget-vast-info"

  @VAST_INFO_API: "/ajax/vast_info"
  @VAST_LOG_API: "/ajax/vast_scan_results"
  @VAST_LOG_RESULT_API: "/ajax/vast_scan_info"

  @SELECTOR_VAST_URL: "[data-vast-wrapper-url]"
  @SELECTOR_VAST_ALERT: ".vast-alert"
  @SELECTOR_VAST_INFO_TABLE: ".vast-info-table"
  @SELECTOR_VAST_LOADER: ".vast-loader"
  @SELECTOR_VAST_INFO_CONTAINER = ".vast-info-container"

  @SELECTOR_MAIN_TABS_CONTAINER = "#creative_main_tabs"
  @SELECTOR_VAST_TAB: "#tab-vast"
  @SELECTOR_VAST_TAB_CONTAINER: "#vast"

  @cache: {}
  @schema: {}

  @activeContainerSelector: ''
  @drawed: false
  @lastError: ''

  @dateFormat = "YYYY-MM-DD"
  @currDate: ''

  @creativeId = null
  @selectedDate = ''

  @selectedItem = null

  constructor: (@el) ->
    @s = @.constructor

    @s.activeContainerSelector = @s.SELECTOR_VAST_TAB_CONTAINER;

    @s.creativeId = $(".vast-log").data 'creative-id';

    $(@s.SELECTOR_VAST_TAB).on 'shown.bs.tab', (e) =>
      @initState()
      @initVastInfo()
      @initLatestScanLink()
      @initVastLog()

  initState: () =>
    @s.currDate = moment().format(@s.dateFormat)
    dateState = @getHashValue('date')
    key = @getHashValue 'key'
    proxy = @getHashValue 'proxy'

    if dateState
      @s.selectedDate = dateState
    else
      @s.selectedDate = @s.currDate
      @addHashParam('date', @s.selectedDate)

    if key && proxy
      @s.selectedItem =
        key: key
        proxy: proxy

  initLatestScanLink: =>
    if $("#{@s.SELECTOR_VAST_INFO_CONTAINER} .panel-heading .latest-scan").length is 0
      latestScan = $("<i class='fa fa-reply latest-scan' title='#{__('vast_log.latest_scan')}'>").tooltip({html: true})
      latestScan.on 'click', () =>
        @addHashParam('key', null)
        @addHashParam('proxy', null)
        $('.proxy span').removeClass("selected")
        @getVastInfo(@s.SELECTOR_VAST_TAB_CONTAINER).then (vastInfo) =>
          @drawTableWithTimeout(vastInfo, @s.SELECTOR_VAST_TAB_CONTAINER)
      $("#{@s.SELECTOR_VAST_INFO_CONTAINER} .panel-heading").append(latestScan)

  initVastLog: =>
    $("#period").val(@s.selectedDate).daterangepicker({
      singleDatePicker: true,
      showDropdowns: false,
      format: @s.dateFormat,
      locale: {
        format: @s.dateFormat,
        applyLabel: __('daterangepicker.applyLabel'),
        cancelLabel: __('daterangepicker.cancelLabel'),
        fromLabel: __('daterangepicker.fromLabel'),
        toLabel: __('daterangepicker.toLabel'),
        customRangeLabel: __('daterangepicker.custom_range'),
        daysOfWeek: moment().lang(get_language()).lang()._weekdaysMin.slice(),
        monthNames: moment().lang(get_language()).lang()._monthsShort.slice(),
        firstDay: 1
      }
    })

    $('#period').on 'apply.daterangepicker', (ev, picker) =>
      @s.selectedDate = picker.element.val()
      @addHashParam('date', @s.selectedDate)
      @addHashParam('key', null)
      @addHashParam('proxy', null)
      @s.logDrawed = off
      @drawLog()

    hideEmpty = @getHashValue 'hide_empty'
    if hideEmpty then @toggleEmptyLogs()

    $('#hide_empty')
      .prop('checked', hideEmpty)
      .on 'change', (e) =>
        if $(e.target).is ":checked"
          @addHashParam('hide_empty', 'true')
          @toggleEmptyLogs()
        else
          @addHashParam('hide_empty', null)
          @toggleEmptyLogs(false)

    @drawLog @s.selectedDate

  drawLog: (date = @s.selectedDate) =>
    if @s.logDrawed
      return

    $(".log-list").showLoader('text-center blue')
    @getVastLog(date).then (log) =>
      unless log
        $(".log-list").hideLoader('text-center blue')
        $(".log-list").html $("<span class='text-center'>").text(__('log.search.empty-result'))
        return

      ul = $ "<ul>"
      for key, item of log
        li = $("<li>").append $("<span>").text "#{item.key}:"
        subItem = @drawItem item
        li.append subItem
        if subItem.hasClass 'empty' then li.addClass('empty')
        ul.append li

      $(".log-list").hideLoader('text-center blue')
      $(".log-list").html('')
      $(".log-list").append ul

      if @s.selectedItem
        if $('.log-list .selected').length
          $('.log-list').scrollTop $('.log-list .selected').position().top - 150

      @s.logDrawed = on

  drawItem: (item) =>
    proxies = item.proxies
    ul = $ "<ul>"
    self = @
    empty = true
    for key, value of proxies
      if !value.xml
        continue

      if !value.empty
        empty = false

      do(ul, key, value) ->
        proxy = key
        scanLink = $("<span class='scan-link'>").text __("vast_log.continent.#{proxy}")

        selectedItem = self.s.selectedItem
        if selectedItem && selectedItem.key is item.key && selectedItem.proxy is proxy
          scanLink.addClass('selected')
          self.selectedItem = null

        scanLink.on 'click', (e) =>
            $('.proxy span').removeClass("selected")
            $(e.target).addClass("selected")
            self.getVastScanResult(item.key, proxy).then (data) ->
              self.drawTableWithTimeout(data.summary_info, self.s.SELECTOR_VAST_TAB_CONTAINER)

        li = $("<li class='proxy'>")
          .append(scanLink)
          .append("&nbsp;&nbsp;")
        if value.empty then li.addClass('empty-item')


        xmlLink = $("<span class='xml-link'>")
          .append(
            $("<a href='#{value.xml}' target='_blank' class='fa fa-file-code-o' title='#{__('vast_log.xml.download')}'>")
              .tooltip()
              .on 'click', (e) => $(e.target).blur()
        )
        li.append(xmlLink)

        ul.append li
    if empty then ul.addClass('empty')
    return ul

  initVastInfo: =>
    if @s.drawed
      return

    if @s.selectedItem
      @getVastScanResult(@s.selectedItem.key, @s.selectedItem.proxy).then (data) =>
        @drawTable(data.summary_info, @s.SELECTOR_VAST_TAB_CONTAINER)
    else
      @getVastInfo().then (vastInfo) =>
        @drawTable(vastInfo)

  drawTableLoader: (selector = @s.activeContainerSelector) =>
    $("#{selector} #{@s.SELECTOR_VAST_INFO_TABLE} tbody")
      .show()
      .html('')
      .append $("<tr>").append($("<td colspan='2' class='loader'>").html("<i class='fa fa-circle-o-notch fa-spin'></i>"))

  drawTableWithTimeout: (data, selector = @s.activeContainerSelector, timeout = 500) =>
    @s.drawed = off
    setTimeout (=>
      @drawTable data, selector
    ), timeout

  drawTable: (vastInfo, selector = @s.activeContainerSelector) =>
    if @s.drawed
      return

    @clearTable(selector)
    tableData = ''
    for colName, colValue of vastInfo
      if !@s.schema[colName]? or 0 == colValue.length
        continue

      type = @s.schema[colName].type
      value = colValue
      tag = 'div'

      if type in ['integer_array', 'string_array']
        value = ''
        for val in colValue
          value += @wrapInTag val, 'li'
        value = @wrapInTag value, 'ol'
      else if colName in ['media_file_urls','vast_tag_urls']
        value = ''
        for key, val of colValue
          if val.is_proxied
            value += @wrapInTag """
                <a href="#{val.url}" target="_blank">#{val.url}</a>
                <br/>
                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                <span class="proxied_url" data-proxied-url="#{val.proxied_to}" data-toggle="tooltip" data-placement="top" title="#{__('vast_info.proxied_link_hint')}">
                  #{__('vast_info.proxied_to')}: #{val.proxied_to}
                </span>
            """, 'li'
          else
            value += @wrapInTag "<a href='#{val.url}' target='_blank'>#{val.url}</a>", 'li'
        value = @wrapInTag value, 'ol'
      else if 'boolean' == type
        if colValue
          value = __('yes')
        else
          value = __('no')
        value = @wrapInTag value, tag
      else
        value = @wrapInTag colValue, tag

      tableData += @getTableRow __("vast_info.schema.#{colName}"), value

    $("#{selector} #{@s.SELECTOR_VAST_INFO_TABLE} tbody")
      .show()
      .append($(tableData))
      .find('.proxied_url')
      .click (e) => @proxyUrlClickHandler(e)
      .tooltip();

    @s.drawed = on
    $(document).trigger "vast-info:drawed"


  wrapInTag: (value, tag, _class='') =>
    if 'textarea' == tag
      result =  "<#{tag} rows=10{class}>#{value}</#{tag}>"
    else
      result = "<#{tag}{class}>#{value}</#{tag}>"

    if _class
      return result.replace '{class}', " class='#{_class}'"
    result.replace '{class}', ''

  getTableRow: (cellName, cellValue) =>
    return "<tr><td class='col-sm-2'><strong>#{cellName}</strong></td><td class='col-sm-10'>#{cellValue}</td></tr>"

  getVastUrl: (selector = @s.activeContainerSelector) ->
    return $("#{selector} #{@s.SELECTOR_VAST_URL}").data 'vastWrapperUrl'

  getVastInfo: (selector = @s.activeContainerSelector) =>
    @drawTableLoader(selector)
    vastUrl = @getVastUrl(selector)
    deferred = $.Deferred()
    if undefined != @s.cache[vastUrl] and @s.cache[vastUrl]
      @closeAlert()
      deferred.resolve @s.cache[vastUrl]
      return deferred.promise()
    else if @s.lastError and no == @s.cache[vastUrl]
      @showAlert @s.lastError
      $(@s.SELECTOR_VAST_INFO_CONTAINER).hide()
      deferred.reject()
      return deferred.promise()

    @s.drawed = no

    opts = {
      url: @s.VAST_INFO_API
      method: 'POST'
      data: {vast: vastUrl}
      cache: no,
    }

    $.ajax(opts).done (resp) =>
      if !resp.status
        @showAlert resp.msg
        $("#{@s.activeContainerSelector} #{@s.SELECTOR_VAST_INFO_CONTAINER} tbody").hide()
        @s.lastError = resp.msg
        @s.cache[vastUrl] = no
        deferred.reject resp.msg
      else
        @closeAlert()
        @s.lastError = ''
        @s.schema = resp.schema
        @s.cache[vastUrl] = resp.msg
        deferred.resolve resp.msg
    .fail =>
      @s.lastError = __('vast_info.unable_to_parse')
      @showAlert @s.lastError
      deferred.reject @s.lastError

    return deferred.promise()

  getVastScanResult: (key, proxy) =>
    @drawTableLoader(@s.SELECTOR_VAST_TAB_CONTAINER)
    @addHashParam('key', key)
    @addHashParam('proxy', proxy)
    cacheKey = "#{@s.creativeId}-#{key}-#{proxy}"
    deferred = $.Deferred()
    if undefined != @s.cache[cacheKey] and @s.cache[cacheKey]
      @closeAlert()
      deferred.resolve @s.cache[cacheKey]
      return deferred.promise()
    else if @s.lastError and no == @s.cache[cacheKey]
      @showAlert @s.lastError
      $("#{@s.SELECTOR_VAST_INFO_TABLE} tbody").hide()
      deferred.reject()
      return deferred.promise()

    opts = {
      url: @s.VAST_LOG_RESULT_API
      method: 'POST'
      data: {
        creative_id: @s.creativeId
        date: @s.selectedDate
        key: key
        proxy: proxy
      }
      cache: no
    }

    $.ajax(opts).done (resp) =>
      if !resp.status
        @showAlert resp.msg
        $("#{@s.activeContainerSelector} #{@s.SELECTOR_VAST_INFO_TABLE} tbody").hide()
        @s.lastError = resp.msg
        @s.cache[cacheKey] = no
        deferred.reject resp.msg
      else
        @closeAlert()
        @s.lastError = ''
        @s.cache[cacheKey] = resp.msg
        @s.schema = resp.schema
        deferred.resolve resp.msg
    .fail =>
      @s.lastError = __('vast_info.unable_to_parse')
      @showAlert @s.lastError
      $("#{@s.activeContainerSelector} #{@s.SELECTOR_VAST_INFO_TABLE} tbody").hide()
      deferred.reject @s.lastError

    return deferred.promise()

  getVastLog: (date) =>
    unless date
      date = @s.currDate

    cacheKey = "#{date}-#{@s.creativeId}"
    deferred = $.Deferred()
    if undefined != @s.cache[cacheKey] and @s.cache[cacheKey]
      deferred.resolve @s.cache[cacheKey]
      return deferred.promise()
    else if @s.lastError and no == @s.cache[cacheKey]
      @showAlert @s.lastError
      $(".vast-log .log-list").html(__('log.search.empty-result'))
      deferred.reject()
      return deferred.promise()

    opts = {
      url: @s.VAST_LOG_API
      method: 'POST'
      data: {
        creative_id: @s.creativeId
        date: date
      }
      cache: no
    }

    $.ajax(opts).done (resp) =>
      if !resp.status
        @showAlert resp.msg
        $(".vast-log .log-list").html(__('log.search.empty-result'))
        @s.lastError = resp.msg
        @s.cache[cacheKey] = no
        deferred.reject resp.msg
      else
        @s.lastError = ''
        @s.cache[cacheKey] = resp.msg
        deferred.resolve resp.msg
    .fail =>
      @s.lastError = __('vast_info.unable_to_parse')
      @showAlert @s.lastError
      deferred.reject @s.lastError

    return deferred.promise()

  clearTable: (selector = @s.activeContainerSelector) =>
    @s.drawed = no
    $("#{selector} #{@s.SELECTOR_VAST_INFO_TABLE} tbody").empty()

  showAlert: (text) =>
    $("#{@s.activeContainerSelector} #{@s.SELECTOR_VAST_ALERT} .alert-text").text text
    $("#{@s.activeContainerSelector} #{@s.SELECTOR_VAST_ALERT}").addClass('alert-danger').removeClass('hidden').show()
    $("#{@s.activeContainerSelector} #{@s.SELECTOR_VAST_LOADER}").addClass 'hidden'

  closeAlert: =>
    $("#{@s.activeContainerSelector} #{@s.SELECTOR_VAST_ALERT}").addClass('hidden')

  proxyUrlClickHandler: (e) =>
    el = $(e.target)
    proxiedUrl = el.attr 'data-proxied-url';
    newTabContainerID = "vast-proxy-tab-" + @genHashFromUrl proxiedUrl
    if $("##{newTabContainerID}").length
      $("#{@s.SELECTOR_MAIN_TABS_CONTAINER} .nav-tabs a[href='##{newTabContainerID}']").tab 'show'
      return true

    navs = $("#{@s.SELECTOR_MAIN_TABS_CONTAINER} .nav-tabs")
    tabs = $("#{@s.SELECTOR_MAIN_TABS_CONTAINER} .tab-content")

    @s.activeContainerSelector = '#' + newTabContainerID

    closeTabBtn = $('<i>')
      .addClass 'fa fa-times opacity-dynamic close-tab'
      .attr 'aria-hidden', 'true'
      .click (e) => @closeProxyVastTab newTabContainerID

    tabLink = $('<a>')
      .attr 'href', "##{newTabContainerID}"
      .attr 'data-toggle', 'tab'
      .html $('a#tab-vast').text()
      .append closeTabBtn

    newNavLi  = $('<li>')
      .attr 'id', "nav-#{newTabContainerID}"
      .append(tabLink)

    newTab = $('<div>')
      .addClass 'tab-pane'
      .attr 'id', newTabContainerID
      .attr 'role', 'tabpanel'

    vastLoader = $("#{@s.SELECTOR_VAST_TAB_CONTAINER} #{@s.SELECTOR_VAST_LOADER}").clone();

    vastAlert = $("#{@s.SELECTOR_VAST_TAB_CONTAINER} #{@s.SELECTOR_VAST_ALERT}").clone();
    vastAlert
      .hide()
      .find '.alert-text'
      .text ''

    vastContainer = $("#{@s.SELECTOR_VAST_TAB_CONTAINER} #{@s.SELECTOR_VAST_INFO_CONTAINER}").clone();
    vastContainer.find('.vast_url').html('').append($('<a>').attr("href", proxiedUrl).attr("target", "_blank").text(proxiedUrl))
    vastContainer.find('.latest-scan').remove()
    vastContainer
      .find "#{@s.SELECTOR_VAST_INFO_TABLE}"
      .attr 'data-vast-wrapper-url', proxiedUrl
      .find 'tbody'
      .empty()

    newTab
      .append vastLoader
      .append vastAlert
      .append vastContainer

    navs.append newNavLi
    tabs.append newTab

    newNavLi.find('a').tab('show')

    @s.drawed = no
    @getVastInfo().then (vastInfo) =>
      @drawTable(vastInfo)

  closeProxyVastTab: (tab) =>
    activeTab = $("#{@s.SELECTOR_MAIN_TABS_CONTAINER} .nav-tabs li.active a").attr 'href'

    $("#{@s.SELECTOR_MAIN_TABS_CONTAINER} .nav-tabs #nav-#{tab}").remove()
    $("#{@s.SELECTOR_MAIN_TABS_CONTAINER} .tab-content ##{tab}").remove()

    if activeTab is "##{tab}"
      newActiveTab = $("#{@s.SELECTOR_MAIN_TABS_CONTAINER} .nav-tabs li:last-child a")
      @s.activeContainerSelector = newActiveTab.attr 'href'
      newActiveTab.tab 'show'

  toggleEmptyLogs: (hide = true) =>
    logList = $('.log-list')
    if hide
      logList.addClass('hide-empty')
    else
      logList.removeClass('hide-empty')

  genHashFromUrl: (url) =>
    hash = 0
    if url.length is 0
      return hash
    for i in [0...url.length]
      chr = url.charCodeAt i
      hash = ((hash << 5) - hash) + chr
      hash |= 0
    return hash

  getHashValue: (key) =>
    matches = location.hash.match new RegExp "#{key}=([^&]*)"
    return if matches then decodeURIComponent(matches[1]) else null

  addHashParam: (key, value) =>
    hash = location.hash.replace('#', '').split('&')

    hashData = {}
    if hash.length
      for item in hash
        item = item.split('=')
        if item[0] && item[1]
          hashData[item[0]] = item[1]

    if !value?
      delete hashData[key]
    else
      hashData[key] = encodeURIComponent(value)

    newHash = []
    for key, value of hashData
      newHash.push "#{key}=#{value}"
    location.hash = newHash.join '&'
